import learnerAxiosInstance from "../../utils/learnerAxiosInstance";

export const validMember = async (accessToken, postParams) => {
    const url = 'is_valid_member';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data?.data;
}

export const renewalEligibility = async (accessToken, postParams) => {
    const url = 'renewal_eligibility';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data;
}

export const renewalCheckout = async (accessToken, postParams) => {
    const url = 'renewal_checkout';
    const axiosInstance = learnerAxiosInstance(accessToken);
    const response      = await axiosInstance.post(url, postParams);
    return response?.data;
}